import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: 900, margin: "auto", padding: 20, fontFamily: "Arial, sans-serif", lineHeight: 1.6 }}>
      <h1>Política de Privacidade para Usuários da Plataforma (Motoristas)</h1>

      <section>
        <h2>1. Introdução</h2>
        <p>
          A presente Política de Privacidade e Proteção dos Dados Pessoais foi elaborada em cumprimento aos dispositivos previstos nas leis de privacidade e proteção de dados, de modo a definir as regras e esclarecer os direitos relacionados à privacidade e proteção dos usuários motoristas da plataforma digital detida pela FLEETDESK LLC, cujo principal local de negócios está em 3280 Habersham Road NW, Atlanta, Geórgia, Estados Unidos da América, 30305-1180 (“Fleetdesk” ou “Nós”).
        </p>
        <p>
          De modo a reforçar o compromisso da Fleetdesk com a cultura da privacidade e segurança das informações, a presente política cumpre seu papel formal e legal.
        </p>
      </section>

      <section>
        <h2>2. Aplicação</h2>
        <p>
          Aplica-se à Fleetdesk, como destinatária dos dados pessoais fornecidos e coletados dos usuários motoristas da plataforma digital pela Fleetdesk (“Plataforma”), e pelos quais a Fleetdesk torna-se responsável – a partir da respectiva coleta – pela utilização, armazenamento e proteção na qualidade de controladora das informações fornecidas conforme a definição legal.
        </p>
      </section>

      <section>
        <h2>3. Dados Pessoais Coletados</h2>
        <p>Ao navegar em nossa Plataforma, podemos vir a coletar os seguintes dados pessoais:</p>
        <ul>
          <li>Dados de identificação direta fornecidos pelo usuário</li>
          <li>Dados de geolocalização e endereço de IP</li>
        </ul>
      </section>

      <section>
        <h2>4. Finalidades do Tratamento de Dados Pessoais</h2>
        <p>Utilizamos os dados pessoais coletados exclusivamente para:</p>
        <ul>
          <li>Possibilitar o acesso e o uso dos recursos e funcionalidades da Plataforma;</li>
          <li>Desenvolver, manter e aperfeiçoar os recursos e funcionalidades da Plataforma;</li>
          <li>Analisar o desempenho da Plataforma, medir a audiência da Plataforma, verificar os hábitos de navegação dos Usuários na Plataforma, a forma pela qual chegaram na página da Plataforma (por exemplo, através de links de outros sites, buscadores ou diretamente pelo endereço), avaliar estatísticas relacionadas ao número de acessos e uso da Plataforma, seus recursos e funcionalidades;</li>
          <li>Análises relacionadas à segurança da Plataforma, aperfeiçoamento e desenvolvimento de ferramentas antifraude;</li>
          <li>Melhorar as experiências de navegação dos Usuários na Plataforma;</li>
          <li>Permitir o fornecimento de serviços mais personalizados e adequados às necessidades dos Usuários, tais como páginas personalizadas e com conteúdo e Serviços mais relevantes;</li>
          <li>Permitir a comunicação entre os Usuários e a Plataforma, inclusive mediante o envio e recebimento de e-mails, SMS ou outros meios de comunicação;</li>
          <li>Identificar os perfis, hábitos e necessidades para eventuais ofertas de serviços e estratégias da Plataforma;</li>
          <li>Cumprimento de obrigações legais e regulatórias;</li>
          <li>Exercício de outras atividades essenciais para a regular operação da Fleetdesk, no âmbito de seu objeto social.</li>
        </ul>
      </section>

      <section>
        <h2>5. Uso de Inteligência Artificial para Rastreamento e Segurança dos Motoristas na Fleetedesk</h2>

        <h3>Compromisso com a Privacidade e Segurança</h3>
        <p>
          A Fleetedesk valoriza a privacidade e a segurança dos motoristas cadastrados e emprega tecnologia de ponta para proteger seus dados. O uso de inteligência artificial (IA) é uma parte fundamental deste compromisso, proporcionando serviços seguros e eficientes.
        </p>

        <h3>Coleta de Dados e Objetivos Específicos</h3>
        <p>
          Os dados poderão ser coletados com o propósito de analisar as seguintes informações do Usuário através do uso de sistemas e aplicativos de IA, como por exemplo:
        </p>
        <ul>
          <li>Análise de Padrões de Condução</li>
          <li>Identificação Biométrica</li>
          <li>Imagens e Vídeos para Detecção de Irregularidades</li>
        </ul>

        <h3>Uso Responsável da Inteligência Artificial</h3>
        <p>
          A IA é aplicada de maneira ética e responsável, processando apenas os dados necessários para os fins declarados. Os algoritmos são projetados para maximizar a segurança e eficiência e minimizar os riscos à privacidade.
        </p>

        <h3>Segurança dos Dados</h3>
        <p>
          Implementamos medidas de segurança robustas para proteger os dados contra acessos não autorizados ou qualquer forma de violação. As operações de processamento são constantemente revistas para alinhar-se às melhores práticas e regulamentações legais.
        </p>

        <h3>Compartilhamento de Dados</h3>
        <p>
          As informações coletadas podem ser compartilhadas com empresas contratantes e autoridades, somente quando necessário para a prestação do serviço, ou para cumprir com obrigações legais, sempre mantendo a transparência com os motoristas.
        </p>

        <h3>Consentimento do Motorista e Direitos de Privacidade</h3>
        <p>
          O consentimento para o uso de IA é solicitado no momento do cadastro na plataforma e pode ser revogado pelo motorista a qualquer momento. A Fleetedesk assegura que todos os motoristas têm seus direitos de privacidade respeitados, incluindo acesso, retificação, exclusão de dados e oposição ao processamento.
        </p>

        <p>
          As cláusulas deste item 5 refletem nosso compromisso em manter a confiança dos nossos motoristas e a conformidade com a legislação vigente. Recomendamos que os motoristas leiam esta política atentamente e entrem em contato para esclarecimentos ou para exercer seus direitos de privacidade.
        </p>
      </section>

      <section>
        <h2>6. Compartilhamento de Dados Pessoais</h2>
        <p>
          Todos os dados, as informações e comunicações coletados são por nós considerados confidenciais, e não serão fornecidos a terceiros, ressalvadas as hipóteses previstas nesta Política.
        </p>
        <p>
          Ao fornecer os dados pessoais, o usuário consente que estes sejam utilizados pela Plataforma e seus Parceiros para entrar em contato com os usuários para obtenção de mais informações e para a oferta de produtos e serviços.
        </p>
        <p>
          Para desenvolver e melhorar os Serviços prestados pela Fleetdesk, poderemos contratar provedores de serviços terceirizados para executar determinadas operações de negócios em nome da Fleetdesk. Ao fazer isso, podemos precisar compartilhar suas informações pessoais com eles. Fornecemos aos nossos provedores de serviço somente informações pessoais de que eles necessitam para realizar os serviços que solicitamos, e exigimos que eles protejam essas informações e não as usem para nenhum outro propósito.
        </p>
        <p>
          A Fleetdesk também pode divulgar seus dados pessoais a terceiros, como fornecedores da Fleetdesk para nossos negócios, como gerenciamento de folha de pagamento, suporte técnico, operação de sistemas de TI.
        </p>
        <p>
          Além disso, poderemos revelar seus dados em caso de: determinação judicial, ordem de autoridade competente ou necessidade de defesa de nossos direitos em demandas judiciais ou administrativas.
        </p>
        <p>
          Adicionalmente, é possível que algumas das transferências citadas acima ocorram para destinatários situados fora do território nacional. Nesta circunstância, as partes se comprometem a fazê-lo somente para países que proporcionem um grau de proteção aos dados pessoais em consonância com às melhores práticas, sempre observado as legislações vigentes, proporcionando assim aos usuários garantias de salvaguardas seus dados, com cláusulas contratuais específicas, sem que haja prejuízo da prévia coleta do seu respectivo consentimento específico, quando aplicável.
        </p>
      </section>

      <section>
        <h2>7. Dados Pessoais Seguros</h2>
        <p>
          A Fleetdesk adota diversas precauções, em observância às diretrizes sobre normas, orientações, padrões e práticas de segurança estabelecidas nas legislações aplicáveis. O acesso às informações coletadas é restrito aos colaboradores e às pessoas autorizadas, aqueles que se utilizarem indevidamente dessas informações, em violação ao disposto contido neste documento, estarão sujeitos às sanções disciplinares e legais cabíveis. Na hipótese de incidência desta natureza, a Fleetdesk ressalta que envidará todos os esforços para remediar e/ou minimizar as consequências do ocorrido, sempre em aderência às melhores práticas de Segurança da Informação, visando desta forma propiciar uma experiência segura e otimizada aos seus usuários.
        </p>
      </section>

      <section>
        <h2>8. Fleetdesk como Controladora de Dados Pessoais</h2>
        <p>
          A Fleetdesk é diretamente responsável pelos dados pessoais, mas pode haver situações em que a Fleetdesk não seja diretamente responsável, mas apenas uma entidade processadora de dados pessoais para terceiros, qualificada como operadora. Quando a Fleetdesk trata dados pessoais como uma operadora de dados pessoais, isso é ordenado por uma terceira parte e a Fleetdesk fica então vinculada às instruções dadas pela terceira parte. Nestas situações, a Fleetdesk não pode garantir que tal tratamento ocorra de acordo com esta Política de Privacidade, mas a Fleetdesk sempre garantirá que o tratamento esteja de acordo com a lei aplicável e, na medida do possível, de acordo com esta Política de Privacidade.
        </p>
      </section>

      <section>
        <h2>9. Retenção e Exclusão de Dados Pessoais</h2>
        <p>
          Caso opte em algum momento pela exclusão de seus dados pessoais do banco de armazenamento, a Fleetdesk poderá reter alguns dados pessoais por um período adicional para fins de cumprimento de obrigações legais ou regulatórias, assim como para eventual exercício regular de direito da Fleetdesk, bem como para fins de auditorias e cumprimento de normas de compliance. A retenção dos dados pessoais será feita durante o prazo necessário ao cumprimento das sobreditas obrigações, sempre respeitando os prazos estabelecidos na legislação aplicável.
        </p>
      </section>

      <section>
        <h2>10. Direitos como Titular de Dados Pessoais</h2>
        <p>A Fleetdesk reserva aos respectivos usuários a possibilidade de exercerem os direitos como titulares de dados pessoais, podendo apresentar solicitações relacionadas aos seus dados pessoais, tais como:</p>
        <ul>
          <li>Confirmação da existência de tratamento;</li>
          <li>Acesso aos dados pessoais;</li>
          <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
          <li>Anonimização, bloqueio ou eliminação de dados desnecessários, ou excessivos, ressalvadas as hipóteses previstas em Lei;</li>
          <li>Portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa pelo usuário;</li>
          <li>Eliminação dos dados tratados com consentimento do usuário, ressalvadas as hipóteses previstas em Lei;</li>
          <li>Obtenção de informações sobre as entidades com as quais compartilhou os seus dados;</li>
          <li>Informação sobre a possibilidade de o usuário não fornecer o consentimento, bem como de ser informado sobre as consequências em caso de negativa;</li>
          <li>Informações relacionadas ao tratamento, armazenagem e destinação dos dados pessoais;</li>
          <li>Revogação do consentimento.</li>
        </ul>
        <p>
          Para exercer os direitos indicados acima, por favor, entre em contato através do e-mail <strong>[e-mail]</strong>.
        </p>
      </section>

      <section>
        <h2>11. Alterações na Política de Privacidade</h2>
        <p>
          A Fleetdesk reforça o seu compromisso com a privacidade das informações fornecidas através da melhoria contínua e aprimoramento da experiência e segurança de seus usuários. Diante disso, as práticas de proteção de dados da Fleetdesk estão sujeitas a alterações. Caso ocorra alguma modificação, a Fleetdesk comunicará seus usuários por meio da Plataforma.
        </p>
      </section>

      <section>
        <h2>12. Informações para Contato</h2>
        <p>
          Em caso de dúvidas, reclamações, elogios ou solicitações relacionadas à Política de Privacidade e Proteção de Dados Pessoais, o usuário pode entrar em contato por meio dos canais abaixo:
        </p>
        <p>
          Fleetdesk LLC<br />
          Endereço: 3280 Habersham Road NW, Atlanta, Geórgia, Estados Unidos da América, 30305-1180<br />
          E-mail: <a href="mailto:privacy@fleetdesk.io">privacy@fleetdesk.io</a><br />         
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
